// @flow
import type { CustomerDetails } from './customer-details'
import { buildCustomerDetails } from './customer-details'
import type { Address } from './address'
import { buildAddress } from './address'

import type { OrderItem } from './order-item'

export type Order = {
  id: ?string,
  token: ?string,
  paymentMethodName: ?string,
  paymentIssuerName: ?string,
  discountCode: ?string,
  customerDetails: CustomerDetails,
  invoiceAddress: Address,
  approvePaymentInTerms: boolean,
  items: { [string]: OrderItem }
}

const buildOrder = function (): Order {
  return {
    id: null,
    token: null,
    paymentMethodName: null,
    paymentIssuerName: null,
    discountCode: null,
    customerDetails: buildCustomerDetails(),
    invoiceAddress: buildAddress(),
    approvePaymentInTerms: false,
    items: {}
  }
}

export {
  buildOrder
}



// WEBPACK FOOTER //
// ./src/types/order.js